module.exports = __webpack_public_path__ + "img/7.fd621e02.jpg";